import React from "react";
export default function References() {
  return (
    <div className="section borderLight">
      <h2>References</h2>
      <p>Coming soon</p>
    </div>
  );
}
